import { getWindow } from '@acorns/web-utils'

export enum Platform {
  Mobile = 'Mobile',
  Desktop = 'Desktop',
  Tablet = 'Tablet',
}

// need to account for tablets, which isMobile does not
const isTouchable = () => {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

export const getPlatform = () => {
  return isTouchable() ? Platform.Mobile : Platform.Desktop
}

export const isAndroid = () => {
  return /Android/i.test(getWindow().navigator.userAgent)
}

export const isApple = () => {
  return /iPhone|iPod|iPad/i.test(getWindow().navigator.userAgent)
}

export default getPlatform()
